import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {SimpleTopAppBar as RmwcSimpleTopAppBar} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const StyledRmwcSimpleTopAppBar = styled(RmwcSimpleTopAppBar)``

const SimpleTopAppBar = ({children, ...otherProps}) => <StyledRmwcSimpleTopAppBar {...otherProps}>{children}</StyledRmwcSimpleTopAppBar>

SimpleTopAppBar.propTypes = {
  children: PropTypes.any
}

export {SimpleTopAppBar}
